import React, { useEffect, useState } from 'react';
import style from './Payment.module.css';
import { Oval } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updatePayment, allPayment } from '../../../actions/payment.action';

const Payments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('curUser'));

  const { loading, success, payments } = useSelector(
    (state) => state.getAllPaymentReducer
  );

  useEffect(() => {
    dispatch(allPayment());
  }, [dispatch]);

  const handlePaymentStatus = (p, val) => {
    dispatch(updatePayment(p._id, val));
    window.location.reload();
  };

  const handleUser = (id) => {
    navigate(`/admin/user/${id}`);
  };
  const handleReport = (report) => {
    navigate(`/submission/${report}`);
  };

  return (
    <>
      <h1 style={{ color: 'rgb(206, 144, 206)' }}>Payments</h1>
      <div className={style.LoginHistory}>
        {loading ? (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        ) : payments && payments.length != 0 ? (
            <div>
              <div className={style.TableHead}>
                <div>Date</div>
                <div>Payment ID</div>
                <div>User</div>
                <div>Report ID</div>
                <div>Amount</div>
                <div>Status</div>
              </div>
              <div>
                {payments.map((p) => {
                  let date = new Date(p.date).toString();
                  const result = date.split(' ');
                  const newDate = `${result[2]}/${result[1]}/${result[3]}`;
                  const newTime = result[4];
                  return (
                    <div className={style.TableData} key={p._id}>
                      <div className={style.TimeDate}>
                        <div className={style.Date}>{newDate}</div>
                        <div className={style.Time}>{`Time - ${newTime}`}</div>
                      </div>
                      <div>{p._id}</div>
                      <div
                        className={style.UserClick}
                        onClick={() => handleUser(p.user?._id || p.user)}
                      >
                        {p.user?.name || p.user}
                      </div>
                      <div
                        className={style.UserClick}
                        onClick={() => handleReport(p.report)}
                      >
                        {p.report}
                      </div>
                      <div>{p.amount}</div>
                      <div>
                        {user && user.user.isAdmin ? (
                          <select
                            value={p.status}
                            onChange={(e) => {
                              handlePaymentStatus(p, e.target.value);
                            }}
                            style={{ marginTop: '20px' }}
                            className='minimal'
                          >
                            <option>Pending</option>
                            <option>Rejected</option>
                            <option>Completed</option>
                          </select>
                        ) : (
                          'NULL'
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className={style.Center} style={{ fontWeight: '500' }}>
              No payment found!
            </div>
          )
        }
      </div>
    </>
  );
};

export default Payments;
